import { faEdit, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { faArrowLeft, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { toast } from 'react-toastify';
import { appraisalDelete } from '../../../../../../api/actions/appraisal/appraisal-delete';
import { CommentButton } from '../../../../../../components/comments/comment-button';
import { Button } from '../../../../../../components/shared/button/button';
import { LinkButton } from '../../../../../../components/shared/link-button/link-button';
import { Popup } from '../../../../../../components/shared/popup/popup';
import { basePerformError } from '../../../../../../helpers/error-helpers';
import { cutStr } from '../../../../../../helpers/string-helpers';
import { IAppraisal } from '../../../../../../models/appraisal';
import { EntityTypes } from '../../../../../../models/enums/entity-types';
import { IGoal } from '../../../../../../models/goal';
import { AppraisalEditor } from './appraisal-editor';

interface IProps extends RouteComponentProps {
    narrativeUid: string,
    participantUid: string,
    title: string,
    appraisals: IAppraisal[],
    goals: IGoal[],
    falseAppraisal?: boolean,
    reload(): void,
}

function AppraisalManagement(props: IProps) {

    const [editPopupVisible, setEditPopupVisible] = useState(false);
    const [editableEntity, setEditableEntity] = useState<IAppraisal>();
    const [entityForDelete, setEntityForDelete] = useState<IAppraisal>();

    return (<>
        <div className="list-title">
            <div>{props.title}:
                <strong> { ( props.appraisals && props.appraisals.length) || 0 }</strong>
            </div>
            <div>
                <Button
                    className="orange"
                    onClick={() => {
                        setEditableEntity(undefined);
                        setEditPopupVisible(true);
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} /> <span>Add Appraisal</span>
                </Button>
            </div>
        </div>
        { props.appraisals && !!props.appraisals.length && (
            <table cellPadding="0" cellSpacing="0" className="list">
                <thead>
                    <tr>
                            <th>Description</th>
                            <th>Goal Congruent</th>
                            <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.appraisals
                        .sort((i1, i2) => i1.description > i2.description ? 1 : (i1.description < i2.description ? -1 : 0) )
                        .map((el: IAppraisal) => (
                            <tr key={el.uid}>
                                <td>
                                    {el.description}
                                </td>
                                <td>
                                    {el.goalCongruent ? 'Yes' : 'No'}
                                </td>
                                <td>
                                    <LinkButton
                                        onClick={() => {
                                            setEditableEntity(el);
                                            setEditPopupVisible(true);
                                        } }
                                    >
                                        <FontAwesomeIcon icon={faEdit} /> Edit
                                    </LinkButton><br />
                                    <LinkButton
                                        className="red"
                                        onClick={async () => {
                                            setEntityForDelete(el);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrashAlt} /> Delete
                                    </LinkButton><br />
                                    <CommentButton
                                        isLink={true}
                                        entityType={EntityTypes.appraisal}
                                        entityUid={el.uid}
                                        taskEntityType={EntityTypes.narrative}
                                        taskEntityUid={props.narrativeUid}
                                    />
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        )}

        { editPopupVisible && (
            <Popup
                title={editableEntity ? 'Edit Appraisal' : 'Add Appraisal'}
                modal={true}
            >
                <AppraisalEditor
                    uid={editableEntity?.uid}
                    onClose={() => setEditPopupVisible(false)}
                    participantUid={props.participantUid}
                    goals={props.goals}
                    reload={props.reload}
                    falseAppraisal={props.falseAppraisal}
                />
            </Popup>
        )}

        { entityForDelete && (
            <Popup
                modal={true}
                className="red"
                title="Delete Appraisal"
                onClose={() => setEntityForDelete(undefined) }
                buttons={[
                    {
                        title: <><FontAwesomeIcon icon={faArrowLeft} /> <span>Cancel</span></>,
                        className: 'gray',
                        onClick: () => setEntityForDelete(undefined),
                    },
                    {
                        title: <><span>Delete</span> <FontAwesomeIcon icon={faTrashAlt} /></>,
                        className: 'red',
                        onClick: async () => {
                            try {
                                const result = await appraisalDelete(entityForDelete.uid);
                                if(result.success) {
                                    props.reload();
                                    toast.success('Item has been successfully delete');
                                    setEntityForDelete(undefined);
                                }
                            }
                            catch(err) {
                                basePerformError(err, props.history);
                            }
                        },
                    },
                ]}
            >
                Are you sure want to delete appraisal: <strong>{cutStr(entityForDelete.description)}</strong>?
            </Popup>
        )}
    </>);
}

const AppraisalManagementWithRouter = withRouter(AppraisalManagement);
export { AppraisalManagementWithRouter as AppraisalManagement };
